module.exports = __webpack_public_path__ + "img/chaping.f51ae7c3.jpg";